import { Language } from './types';

export const SHORTENED_LABELS: Record<Language, Record<string, string>> = {
  EN: {
    shortForwardPending: 'Future',
    shortWaitingForDueDate: 'Date Pending',
    shortWaiting: 'Awaiting Deposit',
    shortPendingDeposit: 'Pending',
    shortNotProcessed: 'Unprocessed',
    shortNewPaymentCreated: 'New Pay',
    shortBalanceDiscounted: 'Balance Deducted',
    shortProviderProcessing: 'Processing',
    shortPendingToApproveByUser: 'Pending to approve',
  },
  ES: {
    shortForwardPending: 'Futuro',
    shortWaitingForDueDate: 'Fecha Pendiente',
    shortWaiting: 'Depósito en Espera',
    shortPendingDeposit: 'Pendiente',
    shortNotProcessed: 'Sin Procesar',
    shortNewPaymentCreated: 'Pago Nuevo',
    shortBalanceDiscounted: 'Saldo Reducido',
    shortProviderProcessing: 'Procesando',
    shortPendingToApproveByUser: 'Pendiente de aprobación',
  },
};

const BASE_LANGUAGE_LABELS = {
  stateCompleted: 'Completed',
  stateCanceled: 'Canceled',
  stateDeposited: 'Completed',
  stateProcessing: 'Processing',
  statePendingToProcess: 'Processing',
  stateForwardPending: 'Forward pending to process',
  stateWaitingForDueDate: 'Waiting for due date',
  stateMissing: 'Missing',
  stateDelivered: 'Delivered',
  stateWaiting: 'Waiting for Deposit',
  statePending: 'Pending',
  statePendingDeposit: 'Waiting deposit',
  stateRejected: 'Rejected',
  stateExpired: 'Expired',
  stateSeen: 'Read',
  stateOpened: 'Opened',
  stateAdd: 'Add Funds',
  stateNotProcessed: 'Not processed',
  stateRemove: 'Withdrawal',
  stateWalletConversion: 'Conversion',
  stateWallet: 'Wallet Payment',
  depositFailed: 'Deposit failed',
  balanceDiscounted: 'Balance discounted',
  stateRefunded: 'Refunded',
  stateNewPaymentCreated: 'New Payment Created',
  stateSwift: 'Swift',
  stateLending: 'Lending',
  stateBitsoDepositError: 'Bitso Deposit Error',
  stateProviderProcessing: 'Provider Processing',
  statePendingToApproveByUser: 'Pending to approve by user',
  statePendingToProcessScheduledPayment: 'Forward pending to process',
  stateActive: 'Active',
  stateInactive: 'Inactive',
  stateDeclined: 'Declined',
  statePendingToDeposit: 'Pending to deposit',
  stateApprovalTimeExpired: 'Time expired',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const STATES_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    stateCompleted: 'Completo',
    stateCanceled: 'Cancelado',
    stateDeposited: 'Completo',
    stateProcessing: 'Procesando',
    statePendingToProcess: 'Procesando',
    stateForwardPending: 'Futuro pendiente de procesar',
    stateWaitingForDueDate: 'Esperando fecha de vencimiento',
    stateMissing: 'Falta',
    stateDelivered: 'Entregado',
    stateWaiting: 'Esperando Deposito',
    statePending: 'Pendiente',
    statePendingDeposit: 'Esperando depósito',
    stateRejected: 'Rechazado',
    stateExpired: 'Expirado',
    stateSeen: 'Visto',
    stateOpened: 'Abierto',
    stateNotProcessed: 'No procesado',
    stateAdd: 'Carga de Fondos',
    stateRemove: 'Retiro',
    stateWalletConversion: 'Conversión',
    stateWallet: 'Wallet Payment',
    depositFailed: 'Fallo de Deposito',
    balanceDiscounted: 'Descuento de Saldo',
    stateRefunded: 'Devuelto',
    stateNewPaymentCreated: 'Nuevo Pago Creado',
    stateSwift: 'Swift',
    stateLending: 'Préstamo',
    stateBitsoDepositError: 'Error de Depósito Bitso',
    stateProviderProcessing: 'Procesando Proveedor',
    statePendingToApproveByUser: 'Pendiente de aprobación por usuario',
    statePendingToProcessScheduledPayment: 'Futuro pendiente de procesar',
    stateActive: 'Activo',
    stateInactive: 'Inactivo',
    stateDeclined: 'Rechazado',
    statePendingToDeposit: 'Pendiente de depositar',
    stateApprovalTimeExpired: 'Tiempo expirado',
  },
};

export default STATES_LANGUAGE_LABELS;
